// Global packages and components
import { useVisibility } from '~/hooks'
import { clsx } from 'clsx'
import {
  BlockColumns,
  BlockContent,
  BlockFeaturedIcons,
  BlockHeroBanner,
  BlockSteps,
  BlockLogoGrid,
  BlockTestimonials,
  Block5050,
  BlockFeaturedContent,
  BlockMainForm,
} from '~/components'
import {
  marginTopDesktop,
  marginBottomDesktop,
  paddingTopDesktop,
  paddingBottomDesktop,
  marginTopMobile,
  marginBottomMobile,
  paddingTopMobile,
  paddingBottomMobile,
  backgroundColourClass,
} from '~/utils'

// Types
type BlockProps = {
  id: string
  name: string
  _type: string
  data: any
  options: {
    paddingTop: number
    paddingBottom: number
    marginTop: number
    marginBottom: number
    paddingTopMob: number
    paddingBottomMob: number
    marginTopMob: number
    marginBottomMob: number
    backgroundColor: string
    hasVisibilityAnimation: boolean
    id: string
  }
}

type BlocksProps = {
  blocks: BlockProps[]
}

// Main component
export default function Blocks({ blocks }: BlocksProps) {
  if (!blocks || blocks?.length == 0) return null

  return blocks.map((item: BlockProps, index: number) => {
    const { blockRef, isVisible } = useVisibility()
    const name = item?.name ? item.name : item?._type ? item._type : ''
    const options = item?.options

    const {
      marginTop,
      marginBottom,
      paddingTop,
      paddingBottom,
      marginTopMob,
      marginBottomMob,
      paddingTopMob,
      paddingBottomMob,
      backgroundColor,
      hasVisibilityAnimation,
      id,
    } = options

    const classes = clsx(`page-block relative page-block--${name}`, {
      [marginTopDesktop(marginTop)]: marginTop,
      [marginBottomDesktop(marginBottom)]: marginBottom,
      [paddingTopDesktop(paddingTop)]: paddingTop,
      [paddingBottomDesktop(paddingBottom)]: paddingBottom,
      [marginTopMobile(marginTopMob)]: marginTopMob,
      [marginBottomMobile(marginBottomMob)]: marginBottomMob,
      [paddingTopMobile(paddingTopMob)]: paddingTopMob,
      [paddingBottomMobile(paddingBottomMob)]: paddingBottomMob,
      [backgroundColourClass(backgroundColor)]: backgroundColor,
      'page-block--has-animation': hasVisibilityAnimation,
      'page-block--is-visible': hasVisibilityAnimation && isVisible,
      'scroll-m-24': id,
    })

    const blockProps = {
      ...item?.data,
      isVisible: isVisible,
    }

    return (
      <div
        id={id}
        key={name + '-' + index}
        ref={blockRef}
        className={classes}
      >
        {name == 'content' ? (
          <BlockContent {...blockProps} />
        ) : name == 'heroBanner' ? (
          <BlockHeroBanner {...blockProps} />
        ) : name == 'logoGrid' ? (
          <BlockLogoGrid {...blockProps} />
        ) : name == 'testimonials' ? (
          <BlockTestimonials {...blockProps} />
        ) : name == 'content' ? (
          <BlockContent {...blockProps} />
        ) : name == 'featuredIcons' ? (
          <BlockFeaturedIcons {...blockProps} />
        ) : name == 'columns' ? (
          <BlockColumns {...blockProps} />
        ) : name == 'steps' ? (
          <BlockSteps {...blockProps} />
        ) : name == '5050' ? (
          <Block5050 {...blockProps} />
        ) : name == 'featuredContent' ? (
          <BlockFeaturedContent {...blockProps} />
        ) : name == 'mainForm' ? (
          <BlockMainForm {...blockProps} />
        ) : null}
      </div>
    )
  })
}
